/**
 * Small/large job threshold for DesignOrderPage's routing decision (instant print-on-demand order
 * vs. a staff-priced custom quote). No such field exists in the data model — this is a tunable
 * frontend constant until Noosa gives a firmer number. See docs/NOOSA-ORDER-INTAKE-TASKS.md Task 8.
 */
export const INSTANT_ORDER_MAX_QUANTITY = 24;
